import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { areConditionsEqual } from "@app/util/viewModel/comparators";

// This function ensures that candidateFilterModel contains testeeFilterModel as a subset.
// If strictMatch is true, then both filters models must be equal to return true
const doesContainFilterModel = (
  candidateFilterModel: Partial<FilterModel>,
  testeeFilterModel: FilterModel,
  implicitFilterFields?: IField[],
  strictMatch?: boolean
): boolean => {
  const implicitFilterFieldNames = new Set((implicitFilterFields ?? []).map(({ name }) => name));
  const candidateFieldNames = Object.keys(candidateFilterModel).filter(
    (fieldName) => !implicitFilterFieldNames.has(fieldName)
  );
  const testeeFieldNames = Object.keys(testeeFilterModel).filter(
    (fieldName) => !implicitFilterFieldNames.has(fieldName)
  );
  const namesOfCandidateModelFieldsWithConditions = candidateFieldNames.filter(
    (name) => candidateFilterModel[name]
  );

  // only proceed with comparison if currently applied filters count is bigger than the expected
  // or if they are of equal size (when strictly matching)
  if (
    namesOfCandidateModelFieldsWithConditions.length > testeeFieldNames.length ||
    ((namesOfCandidateModelFieldsWithConditions.length !== testeeFieldNames.length ||
      !testeeFieldNames.length) &&
      strictMatch)
  ) {
    return false;
  }

  return candidateFieldNames.every((fieldName) =>
    testeeFilterModel[fieldName] && candidateFilterModel[fieldName]
      ? areConditionsEqual(candidateFilterModel[fieldName]!, testeeFilterModel[fieldName])
      : testeeFilterModel[fieldName] === candidateFilterModel[fieldName]
  );
};

export default doesContainFilterModel;
